export default __webpack_public_path__ + "static/media/noRewards.41cedfbb.svg";